import React, { Component } from 'react';
import SidebarMenuRouters from '../../routers/routers';
import Header from '../../containers/header';
import * as formatter from '../../utils/formatters';
import edit from '../../resources/images/estrategas/tools/edit.svg';
import { Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label } from 'reactstrap';
import ListNews from '../../components/listNews';
import {NEWS} from '../../utils/constants';
import * as Request from '../../service/data-info-chart/requestsUtil';
import * as Parse from '../../utils/parsers';
import AddNews from '../../components/addNews';


class News extends Component{

  constructor(props) {
    super(props);
    const date = new Date();
    this.toggle = this.toggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    let today = Parse.toCustomDateLastDay(date);
    let userData = JSON.parse(localStorage.getItem('userData'));
    this.state={ userData: userData, month: (date.getMonth()+1).toString(),
      date: today, news: [], modal: false,  key: 0,
    }
  }

  toggle(){
    this.setState({ modal: !this.state.modal })
  }

  componentDidMount(){
    this.getNews()
  }

  handleChange(evt) {
    const target = evt.target;
    const name = target.name;
    const value = target.value;
    this.setState({ [name]: value });
  }

  getNews(){
    Request.getFetch(NEWS+this.state.date).then(resp=>{
      this.setState({ news: resp }, () =>{
        this.newsList = this.state.news.map(data => <ListNews data={data} callbackFromParent={this.callback}/>);
        this.setState({ key: Math.random() });
      });
    });
  }

  callback= () => {
    this.getNews();
  };

  render() {

    let classUser = (this.state.userData.name === 'Gestor de talento') ? 'quality-edit' : 'quality-edit-unauthorized';

    if (this.state.news!==[]) {
      this.news = this.state.news.map(news => {
        return <div className='col-12 col-md-4 news'>
          <div className='text-center'>
            <img className='news-image' src={news.image} alt=""/>
            <h1 className='news-title'>{news.title}</h1>
          </div>
          <p className='news-body'>{news.body}</p>
        </div>;
      });
    }

    return (
      <div>
        <SidebarMenuRouters profile="/direction-home/" place=''/>
        <Header userName={this.state.userData.name} title='Novedades estrategas'/>
        <div className='d-flex justify-content-center'>
          <p className='header-news'>Noticias estrategas</p>
        </div>
        <div className={classUser}>
          <img src={edit} title="Editar" alt=" " onClick={this.toggle}/>
        </div>
        <Modal size={'lg'} isOpen={this.state.modal} toggle={this.toggle}>
          <ModalHeader className='header-modal'
                       toggle={this.toggle}>Noticias</ModalHeader>
          <ModalBody>
            <h1 className='mt-2 text-center'>Actualización de noticias</h1>
            <div className='edit-news m-3 '>
              <div className='d-flex justify-content-between'>
                <h3 className='edit-news-title'>Agregar Noticias</h3>
                <AddNews callbackFromParent={this.callback}/>
              </div>
              <div className='list-news' key={this.state.key}>
                {this.newsList}
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={this.toggle}>Cerrar</Button>
          </ModalFooter>
        </Modal>
        <div className='d-flex justify-content-center'>
          <p className='title-news'>mes de {formatter.formatStringMonth(this.state.month)}</p>
        </div>
        <div className='row'>
          {this.news}
        </div>
      </div>
    );
  }
}

export default News;



// WEBPACK FOOTER //
// ./src/scene/news/news.js